import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExemploJestService {
  constructor() {}

  somaDoisNumeros(primeiroNumero: number, segundoNumero: number) {
    return primeiroNumero + segundoNumero;
  }
}
